module.exports = window.dnn.nodeModules.Redux;